import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic_close",
  "use": "ic_close-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"ic_close\">\n    <path fill=\"#3D445A\" fill-opacity=\".7\" fill-rule=\"evenodd\" d=\"M12.89 5.818L9.706 9l3.182 3.182-.707.707L9 9.707 5.818 12.89l-.707-.707L8.293 9 5.11 5.818l.707-.707L9 8.293l3.182-3.182.707.707z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol